import { useQuery } from '@tanstack/react-query';

import { getPaymentTimeline } from './api';

export const paymentKeys = {
  all: ['payments'] as const,
  timeline: (id: string) => [...paymentKeys.all, 'timeline', id] as const,
};

/** Timeline for the open drawer. `enabled` only when a row is selected; polls while open so a
 *  final event appears without a manual refresh (ADR-0017). */
export function usePaymentTimeline(paymentId: string | null) {
  return useQuery({
    queryKey: paymentKeys.timeline(paymentId ?? 'none'),
    queryFn: () => getPaymentTimeline(paymentId as string),
    enabled: Boolean(paymentId),
    refetchInterval: paymentId ? 30_000 : false,
  });
}
